<section class="responsive-card d-flex flex-column" aria-labelledby="vb-overview-heading" [style.gap.rem]="0">
  <div class="d-flex justify-content-between">
    <button
      type="button"
      class="no-style-button"
      aria-label="Toggle Variable Benefit Payments details"
      i18n-aria-label
      (click)="collapse.toggle()">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex gap-2 align-items-center">
          <img
            src="assets/icons/grey/Chevron%20Down.svg"
            class="chevron"
            [class.expanded]="!isCollapsed"
            alt=""
            [style.height.rem]="1.5"
            [style.width.rem]="1.5" />
          <span id="vb-overview-heading" class="responsive-card-title" i18n>Variable Benefit Payments</span>
        </div>
      </div>
    </button>
    <app-button
      *ngIf="showUpdateButton"
      [type]="ButtonTypeEnum.primary"
      [disabled]="disableUpdateButton"
      (click)="updatePayments.emit()">
      <div class="d-flex gap-2 align-items-center">
        <span i18n>Update</span>
        <img [src]="chevronSrc" alt="" aria-hidden="true" [style.height.rem]="1.25" [style.width.rem]="1.25" />
      </div>
    </app-button>
  </div>
  <div class="collapse-wrapper" [(ngbCollapse)]="isCollapsed" #collapse="ngbCollapse">
    <div class="collapse-inner">
      <ng-content />
    </div>
  </div>
</section>
